import { useDispatch, useSelector } from "react-redux";
import { editStatus } from "../../redux/state/status";
import { useTranslation } from "react-i18next";
import { faXmark, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface AlertModalProps {
  alertMessage: string;
}

const AlertModal = ({ alertMessage }: AlertModalProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const botButtonColor = useSelector(
    (state: { settings: { botButtonColor: string } }) =>
      state.settings.botButtonColor
  );
  const botFontSize = useSelector(
    (state: { settings: { botFontSize: number } }) =>
      state.settings.botFontSize
  );

  const fontSizesRef = ["xs", "sm", "base", "lg", "xl"];
  const smallFontSizeRef = ["2xs", "xs", "sm", "base", "lg"];
  const fontSizes = [
    fontSizesRef[0 + botFontSize],
    fontSizesRef[1 + botFontSize],
    fontSizesRef[2 + botFontSize],
  ];
  const smallFontSizes = [
    smallFontSizeRef[0 + botFontSize],
    smallFontSizeRef[1 + botFontSize],
    smallFontSizeRef[2 + botFontSize],
  ];

  // Function to close the modal
  const closeAlertModal = () => {
    dispatch(
      editStatus({
        name: "isAlertModal",
        value: false,
      })
    );
  };

  // Function to handle clicks on the background
  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      closeAlertModal(); // Close the modal if the background is clicked
    }
  };

  return (
    <div
      className="fixed inset-0 flex justify-center items-start z-50 mt-20"
      onClick={handleBackgroundClick} // This handles background click
      aria-live="assertive"
    >
      <div
        className="bg-white py-3 px-4 rounded-lg shadow-lg text-center relative transform transition-all duration-300 ease-out"
        style={{ maxWidth: "400px", width: "100%" }}
        role="dialog"
        aria-labelledby="alert-modal-title"
        aria-describedby="alert-modal-description"
      >
        {/* Close Button */}
        <button
          onClick={closeAlertModal}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xs"
          aria-label="Close alert"
        >
          <FontAwesomeIcon icon={faXmark} className="text-red-500" />
        </button>

        {/* Alert Content */}
        <div className="flex items-center space-x-2" id="alert-modal-description">
          <FontAwesomeIcon icon={faCircleExclamation} className="text-yellow-500" />
          <p>{alertMessage}</p>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
